import React, { memo } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

function VendorStatus({ isApproved, isDenied }) {
  const className = classNames('vendor-status', {
    'has-background-info': isApproved,
    'has-background-danger': isDenied,
    'has-background-grey-lighter': !isApproved && !isDenied,
  });

  return <span className={className} />;
}

VendorStatus.propTypes = {
  isApproved: propTypes.bool.isRequired,
  isDenied: propTypes.bool.isRequired,
};

const memoizedVendorStatus = memo(VendorStatus);

export { memoizedVendorStatus as VendorStatus };
